// Which clinics' calls alert this user (ENG-2513). `call_alert_clinic_ids` on
// /me/ lists the clinics they picked; empty (or absent, on an older backend)
// means every call at the practice, which is what everyone had before the
// preference existed. A call that resolved to no clinic alerts everyone. The
// backend applies the same rule to the missed-call push
// (dialstack/notifications.py `wants_call_alerts`); keep the two in step.
//
// This decides alerts only: the missed-call banner, the "Incoming call from"
// snackbar and the history poll. It never changes which phones ring.
export type CallAlertUser = {
  call_alert_clinic_ids?: number[] | null;
} | null;

export function wantsCallAlert(
  user: CallAlertUser | undefined,
  clinicId: number | null | undefined
): boolean {
  const picked = user?.call_alert_clinic_ids;
  if (!picked || picked.length === 0) return true;
  if (clinicId == null) return true;
  return picked.includes(clinicId);
}
